import { Component } from '@angular/core';

@Component({
  selector: 'app-side-bar-mentor',
  templateUrl: './side-bar-mentor.component.html',
  styleUrls: ['./side-bar-mentor.component.css']
})
export class SideBarMentorComponent {

}
